import {EMULATION_STORAGE_COOKIE_KEY} from '../constants/userConstants';

const getCookie = (cookieName) => {
  const regex = new RegExp(`(^| )${cookieName}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }

  return undefined;
};

const getEmulationAuthId = () => {
  try {
    const emulationCookieValue = getCookie(EMULATION_STORAGE_COOKIE_KEY);

    if (!emulationCookieValue) {
      return null;
    }

    return decodeURIComponent(emulationCookieValue);
  } catch (error) {
    return null;
  }
};

export default {
  getEmulationAuthId,
};
